<template>
  <div id="app">
    <!-- <div v-if="showDisplay"> -->
    <header-bar class="header" v-if="showHeader" @changeHelp="changeHelp" @closeHelpDoc="closeHelpDoc" @xiaoyiStatus="xiaoyiStatus"></header-bar>
    <change-product v-if="showHeader"></change-product>
    <homes class="header" v-if="showHomes"></homes>
    <!-- <homes class="header" v-if="showHomes"></homes> -->
    <div class="page-inner" :style="showHeader ? 'padding-top: 60px' : ''">
      <!-- dasdasdasdasdasdasds
      {{currentPathLength}} -->
      <!-- <keep-alive v-if="keepAliveArr.find(n => n===$route.name)">
        <router-view class="page"></router-view>
      </keep-alive> -->
      <router-view class="page" />
      <div v-if="$route.path != '/' && $util.judgeOrigin() == 'DF'">
        <footer-bar v-if="showFooter"></footer-bar>
      </div>
      <!-- 帮助中心 -->
      <help-center ref="helpCenterRef"></help-center>
    </div>
    <!-- 聊天对话框 -->
    <div v-if="allowXy">
      <chat-view ref="chatView" v-if="currentShowChat"></chat-view>
      <chat-img v-if="currentShowChat" @openChat="openChat"></chat-img>
    </div>
    <!-- 用户反馈,只有内部用户可用 -->
    <user-feedback ref="userFeedback"></user-feedback>
    <!-- 心跳弹窗 -->
    <heart-beat ref="heartBeat" :showFooter="showFooter" v-if="showFooter && $util.judgeOrigin() === 'DF'" @inactive="inactive"></heart-beat>
    <!-- </div> -->
    <!-- <div v-else>
      <router-view class="page" />
    </div> -->
  </div>
</template>
<script>
import HeaderBar from './components/header'
import Homes from '@/views/Homes'
import HelpCenter from '@/views/helpCenter'
// import Homet from '@/views/Homet'
import $util from '@/utils/utils'
import ChangeProduct from '@/components/ChangeProduct'
import Watermark from '@/utils/watermarkDemo'
import FooterBar from '@/components/Footer/index.vue'
import { Collapse } from 'element-ui'
import chatView from '@/components/chatView/chat.vue'
import chatImg from '@/components/chatView/chatImg.vue'
import userFeedback from '@/components/chatView/userFeedback.vue'
import heartBeat from '@/components/heartBeat'

export default {
  name: 'App',
  components: {
    HeaderBar,
    FooterBar,
    ChangeProduct,
    heartBeat,
    Homes,
    HelpCenter,
    chatImg,
    chatView,
    userFeedback,
    // Homet
  },
  data() {
    return {
      dialogFormVisible: false,
      screenWidth: null,
      marginWidth: null,
      addClass: false,
      allowXy: false,
      beforeUnloadTime: null,
      timer: null,
      active: 1
    }
  },
  computed: {
    showDisplay() {
      return this.$route.path.indexOf('/report/productChina') != 0
    },
    showHeader() {
      return this.$route.path !== '/login' && this.$route.path.indexOf('/report') < 0 && this.$route.path.indexOf('/homes') < 0
    },
    showHomes() {
      return this.$route.path.indexOf('/login/homes') != -1
    },
    keepAliveArr() {
      return this.$store.getters.keepAliveArr
    },
    dynamicData() {
      return this.$store.getters.dynamicGT6Data
    },
    showFooter() {
      return this.footerStatus(this.$route.path)
    },
    currentShowChat() {
      let allowChatPages = ['/analysis', '/analysis/detail', '/dashboard', '/company/detail', '/business/detail']
      if ((this.$route.path == '/company' || allowChatPages.some(e=>this.$route.path.includes(e))) && ['DF', 'EC', 'TR'].includes(this.$util.judgeOrigin())  && this.$route.path != '/') {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    Watermark.set($util.isTr() ? '' :$util.isTest() ? 'TOPEASE DEMO' : 'TOPEASE')
    window.addEventListener('beforeunload', () => this.beforeunloadFn())
    window.addEventListener("unload", () => this.unloadHandler())
    // window.addEventListener('load', this.load);
    // document.addEventListener('click', (e) => {
    //   let classNameCurrent = e.target.className
    //   let list = document.getElementById('help-cont')
    //   if (classNameCurrent == 'help-icon'||classNameCurrent == 'head_span') {
    //      this.$refs.helpCenterRef.goClose()
    //   }
    // })
  },
  destroyed() {
    // 移除监听
    window.removeEventListener('beforeunload', this.beforeunloadFn);
    window.removeEventListener('unload', this.unloadHandler);
    clearInterval(this.timer) // 清除定时器
    this.timer = null
    sessionStorage.removeItem('openFrom')
  },
  created() {
    // 判断当前路由是否显示
    this.changeFavicon()
    if(this.$util.isLogin()) {
      this.handleWebLog()
    }
    let customerData = setInterval(() => {
      if (!window.localStorage.getItem('gt6_dynamic')) {
        if (this.$util.isLogin() && !this.$route.query.brToken) {
          this.getCustomMenuData()
        }
      } else {
        clearTimeout(customerData)
      }
    }, 1000)
    if (!localStorage.getItem('language')) {
      localStorage.setItem('language', $util.getCurrentBrowseLanguage())
    }
  },
  methods: {
    // 当出现不活跃弹出框时处理逻辑
    inactive(data) {
      this.active = 1*data
    },
    // 移除组件时添加日志
    beforeunloadFn() {
      this.beforeUnloadTime = Date.now()
    },
    unloadHandler() {
      let gapTime = new Date().getTime() - this.beforeUnloadTime
      let log = sessionStorage.getItem('webLog')
      if(log) {
        log = JSON.parse(log)
        log = {...log, timeOnPage:  Date.now(), operation: 'closed', active: this.active}
      }
      if (this.$util.isLogin() && gapTime <= 10) { //判断是窗口关闭还是刷新，小于10代表关闭，否则就是刷新。
        let token = localStorage.getItem("accessToken")
        let data = {...log, token}
        let body = JSON.stringify(data)
        fetch('/api/business/log/logdata/addWebLogs', {
          method: 'POST',
          body,
          headers: {'Content-Type': 'application/json', 'Authorization': token, website: this.$util.getCurrentWebSite(), 'unionKey': 'gt6'},
          keepalive: true
        }).then(res=>{
          console.log(res, 'lll');
        }).catch(err=>{
          console.log(err, 'err');
        });
        // this.$api.logs.addWebLogs(log)
      } else {
        console.log('lkiii');
      }
    },
    xiaoyiStatus(val) {
      this.allowXy = val
    },
    footerStatus(path) {
      let closeFooterArr = ['/login', '/businessDetailReport', '/companyDetailReport', '/productBusiness', '/productChina', '/productReport', '/productReportcompre', '/trendIndustryReport', '/product/biAnalysis']
      // console.log(path)
      // console.log(!closeFooterArr.some((item) => path.includes(item)))
      return !closeFooterArr.some((item) => path.includes(item))
    },
    openChat() {
      this.$nextTick(() => {
        this.$refs.chatView.initOpen()
        // this.$refs.chatView.getHistoryData()
        //传id 为0   且 1  为获取参数初始 的可查询数量
        // this.$refs.chatView.getResponse(0, 1)
      })
    },
    // 切换浏览器图标favicon
    changeFavicon() {
      let icons = {
        JM: '/jmico.ico',
        EC: '/jmico.ico',
        DF: '/gt5icon.ico',
        TR: '/tricon.ico',
      }
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
      let plate = this.$util.judgeOrigin()
      let ico = icons[plate]
      link.href = ico
      document.getElementsByTagName('head')[0].appendChild(link)
    },
    getDataDetail() {
      return new Promise((resolve, reject) => {
        this.$api.home.getHomeData().then((res) => {
          this.$store.commit('set_data_detail', res.data)
          resolve()
        })
      })
    },
    //获取动态菜单
    getCustomMenuData() {
      this.$api.user.getCustomData().then((res) => {
        if (res && res.code == 200) {
          this.$store.commit('dynamic_data', { ...res.data, lang: localStorage.getItem('language') })
          window.localStorage.setItem('gt6_dynamic', JSON.stringify({ ...res.data, lang: localStorage.getItem('language') }))
        }
      })
    },
    // 每隔5s上传日志
    handleWebLog() {
      this.timer = setInterval(() => {
        let log = sessionStorage.getItem('webLog')
        if(log) {
          log = JSON.parse(log)
        } else {
          log = {}
        }
        log = {...log, timeOnPage:  Date.now(), pageTitle: document.title || log.pageTitle, active: this.active}
        this.$api.logs.addWebLogs(log)
      }, 1000 * 5 )
    },
    changeHelp() {
      this.$refs.helpCenterRef.dialogVisible = true
      // if(characteristic&&characteristic=='help-icon')
      this.$refs.helpCenterRef.goDetails()
    },
    closeHelpDoc() {
      this.$refs.helpCenterRef.goClose()
    }
  },
  watch: {
    path() {
      this.$store.commit('change_show_product', false)
    },
    // 处理刷新时浏览器title丢失问题
    'dynamicData.productTitle': {
      handler(val) {
        window.productTitle = val
        let to = this.path
        let productDesc = this.dynamicData.productDesc
        if (to?.meta?.title) {
          //如果设置标题，拦截后设置标题
          if (to.path == '/home') {
            document.title = `${val}-${to.meta.title}-${productDesc}`
          } else {
            document.title = to.meta.title + `-${val}`
          }
        } else {
          document.title = `${val}`
        }
      },
    },
  },
}
</script>
<style lang="scss">
#app {
  height: 100%;
}
.header {
  position: fixed;
  width: 100%;
  z-index: 9999;
  background-color: #ffffff;
  box-sizing: border-box;
}
.page-inner {
  // padding-top: 50px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .page {
    // padding-top: 50px;
  }
}
.footer {
  background-color: #ffffff;
}

</style>
